import acdLogoUrl from "../logos/acd.png";
import acinLogoUrl from "../logos/acin.png";
import astanorLogoUrl from "../logos/astanor.png";
//import circuitLogoUrl from "../logos/circuit.png";
import durofelgueraLogoUrl from "../logos/durofelguera.png";
import elPeriodicoLogoUrl from "../logos/el-periodico.png";
import ercrosLogoUrl from "../logos/ercros.png";
import firaBarcelonaLogoUrl from "../logos/fira_barcelona.png";
import goodmanLogoUrl from "../logos/goodman.png";
import idbLogoUrl from "../logos/idb.png";
import itecLogoUrl from "../logos/itec.png";
import joltLogoUrl from "../logos/jolt.png";
import leitatLogoUrl from "../logos/leitat.png";
import segroLogoUrl from "../logos/segro.png";
import ubLogoUrl from "../logos/ub.png";
import veolialogoUrl from "../logos/veolia.png";

const HOME_LOGOS = [
  { src: acdLogoUrl, alt: "ACD" },
  { src: acinLogoUrl, alt: "ACIN" },
  { src: astanorLogoUrl, alt: "Astanor" },
  // { src: circuitLogoUrl, alt: "Circuit" },
  { src: durofelgueraLogoUrl, alt: "Durofelguera" },
  { src: elPeriodicoLogoUrl, alt: "El Periódico" },
  { src: ercrosLogoUrl, alt: "Ercros" },
  { src: firaBarcelonaLogoUrl, alt: "Fira Barcelona" },
  { src: goodmanLogoUrl, alt: "Goodman" },
  { src: idbLogoUrl, alt: "IDB" },
  { src: itecLogoUrl, alt: "ITEC" },
  { src: joltLogoUrl, alt: "Jolt" },
  { src: leitatLogoUrl, alt: "LEITAT" },
  { src: segroLogoUrl, alt: "Segro" },
  { src: ubLogoUrl, alt: "UB" },
  { src: veolialogoUrl, alt: "Veolia" }
];

function buildHomeLogosMarkup() {
  return `
    <aside class="home-logos" aria-label="Empresas destacadas">
      <div class="home-logos__fade home-logos__fade--top" aria-hidden="true"></div>
      <div class="home-logos__track">
        <div class="home-logos__marquee" data-home-logos-marquee>
          <ul class="home-logos__list" data-home-logos-list>
            ${HOME_LOGOS.map(
              ({ src, alt }) => `
                <li class="home-logos__item">
                  <img class="home-logos__image" src="${src}" alt="${alt}" loading="lazy" />
                </li>
              `
            ).join("")}
          </ul>
          <ul class="home-logos__list" aria-hidden="true">
            ${HOME_LOGOS.map(
              ({ src, alt }) => `
                <li class="home-logos__item">
                  <img class="home-logos__image" src="${src}" alt="" loading="lazy" />
                </li>
              `
            ).join("")}
          </ul>
        </div>
      </div>
      <div class="home-logos__fade home-logos__fade--bottom" aria-hidden="true"></div>
    </aside>
  `;
}

export function initHomeLogos() {
  const homeSafe = document.querySelector(".page--home .home-hero__safe");

  if (!homeSafe || homeSafe.querySelector(".home-logos")) {
    return;
  }

  homeSafe.insertAdjacentHTML("beforeend", buildHomeLogosMarkup());

  const logos = homeSafe.querySelector(".home-logos");
  const list = homeSafe.querySelector("[data-home-logos-list]");
  const marquee = homeSafe.querySelector("[data-home-logos-marquee]");

  if (!logos || !list || !marquee) {
    return;
  }

  const syncHomeLogoLoopDistance = () => {
    const gap = Number.parseFloat(window.getComputedStyle(marquee).rowGap) || 0;
    const items = list.querySelectorAll(".home-logos__item");
    let totalHeight = 0;

    for (let i = 0; i < items.length; i++) {
      const itemHeight = items[i].getBoundingClientRect().height;
      totalHeight += itemHeight;
      if (i < items.length - 1) {
        totalHeight += gap;
      }
    }

    const loopDistance = totalHeight;
    logos.style.setProperty("--home-logos-loop-distance", `${loopDistance}px`);

    const duration = 40;
    logos.style.setProperty("--home-logos-duration", `${duration}s`);
  };

  window.addEventListener("resize", syncHomeLogoLoopDistance);

  const images = list.querySelectorAll("img");
  let pendingCount = 0;

  images.forEach(img => {
    if (img.complete) {
      return;
    }
    pendingCount++;
    img.addEventListener("load", () => {
      pendingCount--;
      if (pendingCount === 0) {
        syncHomeLogoLoopDistance();
      }
    }, { once: true });
  });

  window.requestAnimationFrame(() => {
    syncHomeLogoLoopDistance();
  });
}
